// eslint-disable-next-line no-shadow,no-unused-vars
enum ReduxEmployeesActions {
    // eslint-disable-next-line no-unused-vars
    LOAD_EMPLOYEES = 'loadEmployees'
}

export default ReduxEmployeesActions;
